import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';

export interface TopTabItem {
  key: string;
  title: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-top-tab-view',
  standalone: true,
  templateUrl: './top-tab-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TopTabViewComponent implements OnChanges {
  @Input({ required: true }) tabs: TopTabItem[] = [];
  @Input() activeKey = '';

  @Output() activeKeyChange = new EventEmitter<string>();
  @Output() tabSelected = new EventEmitter<TopTabItem>();

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['tabs'] &&
      this.tabs.length > 0 &&
      !this.tabs.some(tab => tab.key === this.activeKey)
    ) {
      this.activeKey = this.tabs[0].key;
    }
  }

  selectTab(tab: TopTabItem): void {
    if (tab.disabled || tab.key === this.activeKey) {
      return;
    }

    this.activeKey = tab.key;
    this.activeKeyChange.emit(tab.key);
    this.tabSelected.emit(tab);
  }
}
